<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.lotInfo" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(item)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="150"/>
        <vxe-column field="item.name" title="business.label.itemName" width="300"/>
        <vxe-column field="no" title="business.label.lotNo"/>
        <vxe-column field="productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="printProductionDate" title="business.label.printProductionDate" width="100"/>
        <vxe-column field="printValidUntil" title="business.label.printValidUntil" width="100"/>
        <vxe-column field="manufacturer" title="business.label.manufacturer" width="200"/>
        <vxe-column field="producingArea" title="business.label.producingArea" width="100"/>
        <vxe-column field="approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <lot-editor ref="editor" @success="refresh(item)"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'
import LotEditor from '@/views/basedata/item/LotEditor.vue'

export default {
  name: 'LotTable',
  components: { LotEditor },
  data() {
    return {
      loading: false,
      item: new Item(),
      list: []
    }
  },
  methods: {
    refresh(item) {
      this.item = item
      if (this.item.isNew()) {
        return this.$message.warning('请先选择商品')
      }
      this.loading = true
      findAll('lotFactory', { 'item.id': this.item.id }).then(res => {
        if (res.success) {
          this.list = res.result
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.$refs.editor.add(this.item)
    },
    edit(row, copy) {
      this.$refs.editor.edit(row.id, copy)
    }
  }
}
</script>